module.exports = __webpack_public_path__ + "01_long_black.30772f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_long_black.png
// module id = fRjL
// module chunks = 0